import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UICarouselComponent } from './ui-carousel.component';
import { UICarouselItemComponent } from './ui-carousel-item.component';
import { DotsComponent } from './dots.component';
import { UILazyloadDirective } from './ui-lazy-load.directive';
import { ArrowComponent } from './arrow.component';
import { SwiperDirective } from './swiper.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    UICarouselComponent,
    UICarouselItemComponent,
    DotsComponent,
    ArrowComponent,
    SwiperDirective,
    UILazyloadDirective
  ],
  declarations: [
    UICarouselComponent,
    UICarouselItemComponent,
    DotsComponent,
    ArrowComponent,
    SwiperDirective,
    UILazyloadDirective
  ],
  providers: [
  ],
})
export class UICarouselModule { }



// WEBPACK FOOTER //
// ./src/app/shared-components/ui-carousel/index.ts